import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AllRoutes from "./AllRoutes";
import ProtectedRoutes from "./protectedRoutes";
import PageNotFound from "../pages/PageNotFound";
import Login from "../pages/Login";

const RouteWrapper = () => {
  return (
    <Routes>
      <Route path="*" element={<PageNotFound />} />
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/panel/dashboard" />} />
      <Route path="/panel" element={<Navigate to="/panel/dashboard" />} />
      <Route
        path="/panel/*"
        element={
          <ProtectedRoutes>
            <AllRoutes />
          </ProtectedRoutes>
        }
      />
    </Routes>
  );
};

export default RouteWrapper;
